module.exports = require("./nds-NL.d.ts");